module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container logged-out-content"
  }, [_c('form', {
    staticClass: "block form-sm",
    attrs: {
      "name": "forgotPasswordForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.requestPasswordReset()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content text-bold text-center h4"
  }, [_vm._v("\n      Please select the product you would like to reset password for:\n    ")]), _vm._v(" "), _c('context-selector'), _vm._v(" "), (!_vm.requestComplete) ? _c('div', [(_vm.errorMessage) ? _c('error-display', [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.context === 'patient') ? _c('input-text', {
    attrs: {
      "name": "username",
      "label": "Cellphone or email address",
      "validation": _vm.$v.username
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.context === 'practice') ? _c('input-text', {
    attrs: {
      "name": "username",
      "label": "Username",
      "validation": _vm.$v.username
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.context === 'academic') ? _c('input-text', {
    attrs: {
      "name": "username",
      "label": "Email address",
      "validation": _vm.$v.username
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "col-xs-12 pointer text-center"
  }, [_c('submit-button', {
    attrs: {
      "id": "request-password-reset-submit",
      "loading": _vm.loading
    }
  }, [_vm._v("Reset Password")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.requestComplete) ? _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n        If a user with this\n        "), (_vm.context === 'patient') ? _c('span', [_vm._v("cellphone or email address")]) : _vm._e(), _vm._v(" "), (_vm.context === 'practice') ? _c('span', [_vm._v("Username")]) : _vm._e(), _vm._v(" "), (_vm.context === 'academic') ? _c('span', [_vm._v("email address")]) : _vm._e(), _vm._v("\n        exists, then a message will be sent to their registered cell phone or email address with password reset instructions\n      ")])]) : _vm._e()], 1), _vm._v(" "), (_vm.otpAvailable) ? _c('div', [_c('form', {
    staticClass: "block form-sm",
    attrs: {
      "name": "otpSubmitForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendPasswordResetWithOTP()
      }
    }
  }, [(_vm.errorMessage) ? _c('error-display', [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("You can also enter the OTP we have sent to your cellphone to reset your password.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "otp",
      "label": "One Time Pin"
    },
    model: {
      value: (_vm.otpValue),
      callback: function($$v) {
        _vm.otpValue = $$v
      },
      expression: "otpValue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-password', {
    attrs: {
      "name": "password",
      "label": "Enter New Password",
      "validation": _vm.$v.password
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-password', {
    attrs: {
      "name": "confirmPassword",
      "label": "Confirm New Password",
      "validation": _vm.$v.confirmPassword
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "col-xs-12 pointer text-center"
  }, [_c('submit-button', {
    attrs: {
      "id": "perform-password-reset-submit",
      "loading": _vm.loading
    }
  }, [_vm._v("Change Password")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/Patient-Icon.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('h2', [_vm._v("Forgotten Password")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e27cee2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/ForgotPassword.vue
// module id = 680
// module chunks = 5